import type {z} from "zod";
import {EditCustomerOfferNoteBody} from "@project/sdk/sales/zod";
import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const editCustomerOfferNoteTitleSchema = requiredStringSchema(
  EditCustomerOfferNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const editCustomerOfferNoteContentSchema = requiredStringSchema(
  EditCustomerOfferNoteBody.shape.content,
  noteFieldLabelIds.content,
);
export const editCustomerOfferNoteFormSchema = EditCustomerOfferNoteBody.strict().extend({
  title: editCustomerOfferNoteTitleSchema,
  content: editCustomerOfferNoteContentSchema,
});
export type EditCustomerOfferNoteFormPayload = z.output<typeof editCustomerOfferNoteFormSchema>;
export const draftEditCustomerOfferNoteFormSchema = editCustomerOfferNoteFormSchema.partial();
export type DraftEditCustomerOfferNoteFormPayload = z.output<
  typeof draftEditCustomerOfferNoteFormSchema
>;
